import { TableCell, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useHref } from 'react-router-dom';
import CheckboxCell from '../../../../components/ComparativeStudies/Details/CheckboxCell';
import { spaceNumberFormat } from '../../../../utils/jsFunctions';

const API_URL = process.env.REACT_APP_API_URL ?? '';
interface IAdTableRowProps {
  data: Ad;
  folders: Folders | null;
  needCheck: boolean;
}

const useStyles = makeStyles({
  cell: {
    padding: 0,
    textAlign: 'center',
    '& a': {
      textDecoration: 'none',
      color: '#000',
    },
  },
  img: {
    padding: 0,
    textAlign: 'center',
    verticalAlign: 'middle',
    '& img': {
      width: '40px',
    },
  },
});

function AdTableRow({ data, folders, needCheck }: IAdTableRowProps) {
  const classes = useStyles();

  const url = useHref(`/ad?id=${data.idIri}`);

  const studiedContentDisplay = (data: any) => {
    if (!data.isStudied) {
      return ' - ';
    } else if (folders) {
      const folderIriTab = folders.map((f) => f.idIri);
      const c = 0;
      let sharedFolder = undefined;

      while (c < data.studied.length && !sharedFolder) {
        sharedFolder = data.studied.find((e: any) => folderIriTab.includes(e));
      }

      return sharedFolder.idIri;
    }
  };

  const handleRowClick = () => {
    if (data) {
      window.open(url, '_blank');
    }
  };

  const handleDeadUrl = (e: any) => {
    e.target.src = '/images/logo-prospecimmo.svg';
  };

  return (
    <TableRow>
      {needCheck && <CheckboxCell data={data} />}
      <TableCell className={classes.img} onClick={handleRowClick}>
        <img
          src={data.picture ?? '/images/logo-prospecimmo.svg'}
          onError={handleDeadUrl}
          alt="good"
        />
      </TableCell>
      <TableCell className={classes.cell}>{data.propertyTypology.name}</TableCell>
      <TableCell className={classes.cell} onClick={handleRowClick}>
        {`${spaceNumberFormat({
          value: data.builtArea,
          withEuro: false,
          decimal: true,
        })} m²`}
      </TableCell>
      <TableCell className={classes.cell} onClick={handleRowClick}>
        {`${spaceNumberFormat({
          value: data.landArea,
          withEuro: false,
          decimal: true,
        })} m²`}
      </TableCell>
      <TableCell className={classes.cell} onClick={handleRowClick}>
        {data.city.name}
      </TableCell>
      <TableCell className={classes.cell}>
        {data.source ? data.source.label : 'Indéfini'}
      </TableCell>
      <TableCell className={classes.cell} onClick={handleRowClick}>
        {data.price ? spaceNumberFormat({ value: data.price, withEuro: true }) : '-'}
      </TableCell>
      <TableCell className={classes.cell}>{data.status}</TableCell>
      <TableCell className={classes.cell}>
        {studiedContentDisplay(data.studied)}
      </TableCell>
    </TableRow>
  );
}

export default AdTableRow;
